import { GetCatalogProductViewQuery } from '@notino/shared/definitions/types';

import { isInfantFormula } from '@containers/ProductDetailContainer/ProductDetail/ProductBaseInfo/utils/isInfantFormula';
import { isDiorBrand } from '@containers/ProductDetailContainer/ProductDetail/utils';
import { ICampaign } from '@containers/ProductListing/model';

export const getGiftCampaigns = ({
  product: { campaigns, brand },
  variant,
}: {
  product: {
    campaigns: NonNullable<
      GetCatalogProductViewQuery['productDetailByCatalogMasterId']
    >['campaigns'];
    brand: Pick<
      NonNullable<
        NonNullable<
          GetCatalogProductViewQuery['productDetailByCatalogMasterId']
        >['brand']
      >,
      'id'
    > | null;
  };
  variant: Pick<
    NonNullable<
      GetCatalogProductViewQuery['productDetailByCatalogMasterId']
    >['variants'][number],
    'navigationValues' | 'webId'
  >;
}): {
  giftCampaigns: ICampaign[];
  hasGiftCampaigns: boolean;
  trackingAttrs: {
    moreGifts: boolean;
    giftAvailable: boolean;
  };
} => {
  const EMPTY = {
    giftCampaigns: [],
    hasGiftCampaigns: false,
    trackingAttrs: {
      giftAvailable: false,
      moreGifts: false,
    },
  };

  if (
    isInfantFormula(variant) ||
    !Array.isArray(campaigns) ||
    campaigns.length === 0
  ) {
    return EMPTY;
  }

  const filteredCampaigns = campaigns.filter(
    (campaign): campaign is NonNullable<typeof campaign> =>
      !!campaign &&
      !!campaign.displayOnDetailPage &&
      variant.webId === campaign.productId &&
      !!(campaign.detailPageText || campaign.text)
  );

  if (filteredCampaigns.length === 0) {
    return EMPTY;
  }

  const giftCampaigns = isDiorBrand(brand?.id ?? '')
    ? [filteredCampaigns[0]]
    : filteredCampaigns;

  return {
    hasGiftCampaigns: giftCampaigns.length > 0,
    giftCampaigns: giftCampaigns as ICampaign[],
    trackingAttrs: {
      moreGifts: giftCampaigns.length > 2,
      giftAvailable: giftCampaigns.length > 0,
    },
  };
};
